<div class="lr-verification-page">
  <div class="loading-state" *ngIf="isLoading">
    <img src="/assets/images/ff_logo.svg" alt="FreightFox" class="brand-logo">
    <div class="spinner"></div>
  </div>

  <div class="error-state" *ngIf="!isLoading && errorMessage">
    <img src="/assets/images/ff_logo.svg" alt="FreightFox" class="brand-logo">
    <p class="error-text">{{ errorMessage }}</p>
  </div>

  <ng-container *ngIf="!isLoading && !errorMessage">
    <div class="approved-view" *ngIf="step === 'approved' || step === 'rejected'">
      <div class="accepted-badge" *ngIf="step === 'approved'">
        <span class="accepted-icon" aria-hidden="true">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <circle cx="8" cy="8" r="7.25" stroke="#0B6E99" stroke-width="1.5"/>
            <path d="M4.5 8.2l2.2 2.2 4.8-4.8" stroke="#0B6E99" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
        <span>LR marked as Accepted</span>
      </div>

      <div class="rejected-badge" *ngIf="step === 'rejected'">
        <span class="rejected-icon" aria-hidden="true">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <circle cx="8" cy="8" r="7.25" stroke="#C53030" stroke-width="1.5"/>
            <path d="M5.5 5.5l5 5M10.5 5.5l-5 5" stroke="#C53030" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </span>
        <span>LR marked as Rejected</span>
      </div>

      <div class="lr-ticket">
        <div class="ticket-header">
          LR No: {{ lrNumber }}
        </div>

        <div class="ticket-body">
          <div class="route-row">
            <div class="route-point">
              <span class="route-icon origin-icon" aria-hidden="true">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="3" stroke="#17709c" stroke-width="1.8"/>
                  <circle cx="12" cy="12" r="7" stroke="#17709c" stroke-width="1.5"/>
                  <path d="M12 2v2M12 20v2M2 12h2M20 12h2" stroke="#17709c" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
              </span>
              <span class="route-text">{{ fromLocation }}</span>
            </div>

            <span class="route-arrow" aria-hidden="true">→</span>

            <div class="route-point">
              <span class="route-icon destination-icon" aria-hidden="true">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path d="M12 21s7-5.2 7-11a7 7 0 10-14 0c0 5.8 7 11 7 11z" stroke="#17709c" stroke-width="1.6"/>
                  <path d="M9.5 10.5V8.8L12 7l2.5 1.8v1.7H9.5z" stroke="#17709c" stroke-width="1.4" stroke-linejoin="round"/>
                </svg>
              </span>
              <span class="route-text">{{ toLocation }}</span>
            </div>
          </div>

          <div class="ticket-divider"></div>

          <div class="details-grid">
            <div class="detail-item">
              <span class="detail-label">Truck Number</span>
              <span class="detail-value">{{ truckNumber }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">Reported Time</span>
              <span class="detail-value">{{ reportedTime }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">Invoice No.</span>
              <span class="detail-value">{{ invoiceNumber }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">Invoice Value</span>
              <span class="detail-value">{{ invoiceValue }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="flow-card" *ngIf="step === 'login'">
      <img src="/assets/images/ff_logo.svg" alt="FreightFox" class="brand-logo">

      <h1 class="page-title">Log In to view LR</h1>

      <div class="form-field">
        <label for="contact-input">Email / Phone Number</label>
        <input
          id="contact-input"
          type="text"
          [(ngModel)]="contactInput"
          placeholder="Input here"
          autocomplete="username"
        >
      </div>

      <button
        type="button"
        class="primary-action"
        [disabled]="!canSendOtp"
        (click)="sendOtp()">
        Send OTP
      </button>
    </div>

    <div class="flow-card" *ngIf="step === 'otp'">
      <img src="/assets/images/ff_logo.svg" alt="FreightFox" class="brand-logo">

      <div class="otp-header">
        <button type="button" class="back-btn" (click)="goBackToLogin()" aria-label="Back">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <h1 class="page-title otp-title">Log In to view LR</h1>
      </div>

      <p class="otp-sent">OTP sent to {{ maskedContact }}</p>

      <div class="form-field otp-field">
        <label>Enter OTP</label>
        <div class="otp-boxes">
          <input
            *ngFor="let digit of otpDigits; let i = index; trackBy: trackByIndex"
            #otpBox
            class="otp-box"
            type="text"
            inputmode="numeric"
            maxlength="1"
            autocomplete="one-time-code"
            [value]="digit"
            placeholder="-"
            (input)="onOtpInput($event, i)"
            (keydown)="onOtpKeydown($event, i)"
            (paste)="onOtpPaste($event)"
          >
        </div>
      </div>

      <div class="otp-actions">
        <span class="otp-timer">{{ remainingTime }}</span>
        <button
          type="button"
          class="resend-btn"
          [disabled]="!canResendOtp || isResending"
          (click)="resendOtp()">
          {{ isResending ? 'Sending...' : 'Resend OTP' }}
        </button>
      </div>

      <p class="otp-error" *ngIf="otpError">{{ otpError }}</p>

      <button
        type="button"
        class="primary-action continue-btn"
        [disabled]="!canContinue"
        (click)="onContinue()">
        {{ isSubmitting ? 'Verifying...' : 'Continue' }}
      </button>
    </div>
  </ng-container>
</div>
